
import axios from "axios";

const REACT_APP_API_URL = process.env.REACT_APP_API_URL || "http://127.0.0.1:8000";


export const getSidebarUserInfo = async () => {
    const token = localStorage.getItem("authToken");
  
    if (!token) throw new Error("Unauthorized: No token found.");
  
    const response = await axios.get(`${REACT_APP_API_URL}/my/sidebar-info`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  
    return response.data;
  };
  